<template>
  <div class="amsproduct" >
    <Header />
    <Banner />
    <AmsProductPage />
    <Footer />
  </div>
</template>

<script>
import Banner from '../components/Banner.vue'
import Footer from '../components/Footer.vue'
import Header from '@/components/Header.vue'
import AmsProductPage from '@/components/AmsProductPage.vue'

export default {
  name: 'docproduct',
  components: {
    AmsProductPage,
    Header,
    Banner,
    Footer,
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     // 滚动到窗口的指定位置（例如 500px）
  //     window.scrollTo({
  //       top: 500,
  //       behavior: 'smooth' // 可选平滑滚动
  //     });
  //   });
  // },
}
</script>

<style lang="scss">
// .amsproduct{
//   scroll-behavior: smooth;
//   overflow-y: auto;
// }
</style>